import TYPES from '@/modules/shared/types';

// Domain
import { InvestmentTypeRepository } from '../../domain/repository';
import { InvestmentTypeDto } from '../../domain/dtos/investment-type-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class InvestmentTypeHttpRepository implements InvestmentTypeRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/investment-types/`;

  execute(score: string): Promise<InvestmentTypeDto> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.concat(score))
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
